<form
  name="step.form"
  #currentForm="ngForm"
  *ngIf="step && !isLoading()"
  class="inv-user"
  novalidate
>
  <div class="group">
    <p *ngIf="step">User name *</p>
    <input
      autocomplete="off"
      name="username"
      placeholder="Enter user name"
      [(ngModel)]="username"
      maxlength="30"
      minlength="3"
      pattern="^[a-zA-Z0-9-_]+$"
      (ngModelChange)="userNameUpdated()"
      #userNameInput="ngModel"
      ngModel
      required
    />
    <div
      class="error"
      *ngIf="userNameInput.invalid && (userNameInput.dirty || userNameInput.touched)"
    >
      <mat-error *ngIf="userNameInput.errors.required">Username is required</mat-error>
      <mat-error *ngIf="userNameInput.errors.minlength">Username is too short. (Min 3)</mat-error>
      <mat-error *ngIf="userNameInput.errors.pattern"
        >Username has unexpected characters. Use only [ a-z, A-Z, 0-9, -, _ ]</mat-error
      >
    </div>
  </div>
  <div class="group">
    <p *ngIf="step">Name *</p>
    <input
      autocomplete="off"
      name="name"
      placeholder="Enter name"
      [(ngModel)]="name"
      maxlength="100"
      #nameInput="ngModel"
      ngModel
      (ngModelChange)="nameUpdated()"
      required
    />
    <div class="error" *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)">
      <mat-error *ngIf="nameInput.errors.required">Name is required</mat-error>
    </div>
  </div>
  <div class="group">
    <p *ngIf="step">Surname *</p>
    <input
      autocomplete="off"
      name="surname"
      placeholder="Enter surname"
      [(ngModel)]="surname"
      maxlength="100"
      #surNameInput="ngModel"
      (ngModelChange)="surNameUpdated()"
      required
    />
    <div class="error" *ngIf="surNameInput.invalid && (surNameInput.dirty || surNameInput.touched)">
      <mat-error *ngIf="surNameInput.errors.required">Surname is required</mat-error>
    </div>
  </div>
  <div class="group">
    <p *ngIf="step">Email address *</p>
    <input
      autocomplete="off"
      type="email"
      name="email"
      placeholder="Enter email address"
      [(ngModel)]="email"
      minlength="5"
      maxlength="100"
      #emailInput="ngModel"
      (ngModelChange)="emailUpdated()"
      pattern="^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\:[0-9]+)?$"
      required
    />
    <div class="error" *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
      <mat-error *ngIf="emailInput.errors.minlength">Email is too short</mat-error>
      <mat-error *ngIf="emailInput.errors.maxlength">Email is too long</mat-error>
      <mat-error *ngIf="emailInput.errors.required">Email is required</mat-error>
      <mat-error *ngIf="emailInput.errors.pattern">Email is invalid</mat-error>
    </div>
  </div>
  <div class="group">
    <p *ngIf="step">Password *</p>
    <input
      autocomplete="new-password"
      type="password"
      name="password"
      placeholder="Enter Password"
      [(ngModel)]="password"
      minlength="5"
      maxlength="30"
      #passwordInput="ngModel"
      (ngModelChange)="passwordUpdated()"
      [fieldMatch]="passwordConfirmInput.control"
      [reverse]="true"
      passwordStrength
      [passwordValidationOptions]="passwordValidationOptions"
      (passwordScore)="step.passwordStrength = $event"
      (passwordSuggestions)="step.passwordSuggestions = $event"
      required
    />
    <div
      class="label password-count"
      [ngClass]="step.output.password.length >= 5 ? 'label-success' : 'label-danger'"
    >
      {{ step.output.password | passwordCount:5 }}
    </div>

    <strength-meter [passwordScore]="step.passwordStrength"></strength-meter>
    <div
      class="error"
      *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)"
    >
      <mat-error *ngIf="passwordInput.errors.required">Password is required</mat-error>
      <mat-error *ngIf="passwordInput.errors.minlength"
        >Password must have at least 5 characters</mat-error
      >
      <mat-error
        *ngIf="!passwordInput.errors.minlength && passwordInput.errors.pattern === 'bad' && userService.isActiveTestProject()"
        >The password does not meet the minimum complexity requirements: upper and lower case, at
        least one number, and one non-alphanumeric symbol.</mat-error
      >
      <mat-error *ngIf="passwordInput.errors.strength"
        ><span *ngFor="let suggestion of step.passwordSuggestions">{{suggestion}}</span></mat-error
      >
    </div>
  </div>
  <div class="group">
    <p *ngIf="step">Confirm password *</p>
    <input
      type="password"
      name="confirmPassword"
      placeholder="Confirm Password"
      [(ngModel)]="confirmPassword"
      minlength="5"
      maxlength="30"
      (ngModelChange)="confirmPasswordUpdated()"
      #passwordConfirmInput="ngModel"
      [fieldMatch]="passwordInput.control"
      required
    />
    <div
      class="error"
      *ngIf="passwordConfirmInput.invalid && (passwordConfirmInput.dirty || passwordConfirmInput.touched)"
    >
      <mat-error *ngIf="passwordConfirmInput.errors.required">Password is required</mat-error>
      <mat-error *ngIf="passwordConfirmInput.errors.fieldMatch">Passwords do not match</mat-error>
    </div>
  </div>
</form>

<div *ngIf="isLoading()" class="loader">
  <div class="loader-msg-header">
    <p>Adding user</p>
  </div>
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
